import { Routes } from '@angular/router';
import { SuivisComponent } from './suivis.component';
import { SuiviInventairesVergersComponent } from './pages/suivi-inventaires-vergers/suivi-inventaires-vergers.component';
import { SuiviDeclarationsRecolteComponent } from './pages/suivi-declarations-recolte/suivi-declarations-recolte.component';
import { VergersEcoresponsablesComponent } from '../engagements/pages/vergers-ecoresponsables/vergers-ecoresponsables.component';
import { SuiviStocksComponent } from './pages/suivi-stocks/suivi-stocks.component';
import { SuiviEcoulementsComponent } from './pages/suivi-ecoulements/suivi-ecoulements.component';

import { FicheEntrepriseComponent } from '../administration/pages/entreprises/pages/fiche-entreprise/fiche-entreprise.component';

export const SUIVIS_ROUTES: Routes = [
    {
        path: '',
        component: SuivisComponent,
        data: {
            role: 'ORGANISME || GP',
            domaines: ['ANPP'],
            menu: {
                icon: 'chart-line',
                libelle: 'menu.suivis'
            }
        },
        children: [
            {
                path: 'suivi-inventaires-vergers',
                children: [
                    {
                        path: '',
                        component: SuiviInventairesVergersComponent,
                        data: {
                            role: 'ORGANISME || GP',
                            domaines: ['ANPP'],
                            menu: {
                                libelle: 'menu.suivi-inventaire-verger',
                                icon: 'cogs'
                            }
                        }
                    },
                    {
                        path: '../../admin/entreprises/fiche/:id',
                        component: FicheEntrepriseComponent,
                        data: { roles: ['ORGANISME'] }
                    }
                ]
            },
            {
                path: 'suivi-recoltes',
                children: [
                    {
                        path: '',
                        component: SuiviDeclarationsRecolteComponent,
                        data: {
                            role: 'ORGANISME',
                            domaines: ['ANPP'],
                            menu: {
                                libelle: 'menu.recoltes',
                                icon: 'cogs'
                            }
                        }
                    }
                ]
            },
            {
                path: 'suivi-engagements-vergers-ecoresponsables',
                children: [
                    {
                        path: '',
                        component: VergersEcoresponsablesComponent,
                        data: {
                            role: 'ORGANISME',
                            domaines: ['ANPP'],
                            menu: {
                                libelle: 'menu.vergers-ecoresponsables',
                                icon: 'cogs'
                            }
                        }
                    }
                ]
            },
            {
                path: 'suivi-stocks',
                children: [
                    {
                        path: '',
                        component: SuiviStocksComponent,
                        data: {
                            role: 'ORGANISME',
                            domaines: ['ANPP'],
                            menu: {
                                libelle: 'menu.stocks',
                                icon: 'cogs'
                            }
                        }
                    }
                ]
            },
            {
                path: 'suivi-ecoulements',
                children: [
                    {
                        path: '',
                        component: SuiviEcoulementsComponent,
                        data: {
                            role: 'ORGANISME',
                            domaines: ['ANPP'],
                            menu: {
                                libelle: 'menu.ecoulements',
                                icon: 'cogs'
                            }
                        }
                    }
                ]
            }
        ]
    }
];
